// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const {
  keyedReviver,
  listReviver
} = require('client-v2/common/state/revivers')

class HeroSectionSlideRecord extends Immutable.Record({
  image: String(),
  headline: String()
}) {
  // No methods
}

HeroSectionSlideRecord.reviver = keyedReviver(HeroSectionSlideRecord, {
  // No nested data structures
})

class HeroSectionRecord extends Immutable.Record({
  slides: Immutable.List()
}) {
  // No methods
}

HeroSectionRecord.reviver = keyedReviver(HeroSectionRecord, {
  slides: listReviver(HeroSectionSlideRecord.reviver)
})

module.exports = HeroSectionRecord
